import { render } from "./ManagerSettingsPage.vue?vue&type=template&id=fd6cf040&scoped=true"
import script from "./ManagerSettingsPage.vue?vue&type=script&lang=js"
export * from "./ManagerSettingsPage.vue?vue&type=script&lang=js"

import "./ManagerSettingsPage.vue?vue&type=style&index=0&id=fd6cf040&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fd6cf040"]])

export default __exports__